<form
  [formGroup]="formGroup"
  [bitSubmit]="submit"
  bit-dialog
  dialogSize="default"
  class="bv-account-dialog"
  [title]="'purgeVault' | i18n"
>
  <ng-container bitDialogContent>
    <p class="bv-account-dialog__body-text">
      {{ (organizationId ? "purgeOrgVaultDesc" : "purgeVaultDesc") | i18n }}
    </p>
    <bit-callout type="warning" icon="bwi-info-circle">{{
      "purgeVaultWarning" | i18n
    }}</bit-callout>
    <app-user-verification formControlName="masterPassword"></app-user-verification>
  </ng-container>
  <ng-container bitDialogFooter>
    <div class="bv-account-dialog__footer-end">
      <button
        bitButton
        bitFormButton
        type="button"
        buttonType="secondary"
        class="bv-account-dialog__cancel-btn"
        bitDialogClose
      >
        {{ "cancel" | i18n }}
      </button>
      <button
        bitButton
        bitFormButton
        type="submit"
        buttonType="danger"
        class="bv-account-dialog__danger-outline-btn"
      >
        {{ "purgeVault" | i18n }}
      </button>
    </div>
  </ng-container>
</form>
